export enum ErrorCodeEnum {
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  CONSENT_NOT_FOUND = 'CONSENT_NOT_FOUND',
  CONSENT_NOT_APPROVED = 'CONSENT_NOT_APPROVED',
  AC_NOT_FOUND = 'AC_NOT_FOUND',
  DOCTOR_NOT_FOUND = 'DOCTOR_NOT_FOUND'
}
